import { postLandings } from '../api/postLandings';

export const setPostLandings = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postLandings(params);
            
            alert('Сохранено')
          
            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}